export default "__VITE_ASSET__8384d140__"